module.exports = __webpack_public_path__ + "static/img_5101-d5032aa84085119b16b9dab3fbdc5eb2.webp";